import PropTypes from 'prop-types'
import React from 'react'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { setProfileAdsError, fetchUserInfo } from 'SRC/modules/users/Profile/actions'
import { getUserInfo } from 'src/modules/users/Profile/selectors'
import { updateAdById } from '../../../../actions'
import { connect } from 'react-redux'
import { adsStatues } from 'SRC/modules/ads/shared/constants'

export class AutoRefresh extends React.Component {
  getLimitExceededMessage () {
    const userActiveAddons = this.props.user.activeAddons
    if (userActiveAddons && userActiveAddons.length) {
      const refreshAddon = userActiveAddons.find(addon => addon.action.label === 'refresh')
      if (refreshAddon) {
        const count = refreshAddon.actionCount
        return `Već ste obnovili ${count} ${count > 1 ? 'oglasa' : 'oglas'}, 
        sledeći možete obnoviti za 48h od poslednje obnove, ili da aktivirate 
        REFRESH dodatak koji vam omogućava obnavljanje većeg broja oglasa. 
        Pogledajte sve DODATKE.`
      }
      const autoRefreshAddon = userActiveAddons.find(addon => addon.action.label === 'autoRefresh')
      if (autoRefreshAddon) {
        return `Već ste obnovili 1 oglas
        sledeći možete obnoviti za 48h od poslednje obnove, ili da aktivirate 
        REFRESH dodatak koji vam omogućava obnavljanje većeg broja oglasa. 
        Pogledajte sve DODATKE.`
      }
    }

    return null
  }

  toggleAutoRefresh = async () => {
    const helper = new CookiesHelper()
    const token = helper.get('token')
    const userId = helper.get('userId')
    const adId = this.props.adId

    if (token && userId && adId) {
      this.props.updateAdById(adId, {isLoading: true})
      const fields = {token, userId, adId}
      const api = new AdApi()
      const {status} = !this.props.autoRefresh ? await api.setAutoRefresh(fields) : await api.clearAutoRefresh(fields)
      console.log(status)
      if (status === AdApi.setAutoRefreshResponseStatuses.SUCCESS) {
        let updateAdFields = {
          autoRefresh: !this.props.autoRefresh,
          status: adsStatues.PUBLISHED.code,
          isLoading: false
        }
        if (this.props.initRefresh) updateAdFields = {...updateAdFields, refreshed: new Date().toISOString()}
        this.props.updateAdById(adId, updateAdFields)
        this.props.fetchUserInfo(userId, token, true)
      } else {
        if (!this.props.autoRefresh) {
          switch (status) {
            case AdApi.setAutoRefreshResponseStatuses.WRONG_AD_STATUS:
              this.props.setProfileAdsError('Pogrešan status oglasa'); break
            case AdApi.setAutoRefreshResponseStatuses.REFRESH_LIMIT_WAS_EXCEEDED:
              this.props.setProfileAdsError(this.getLimitExceededMessage()); break
            case AdApi.setAutoRefreshResponseStatuses.AUTO_REFRESH_ALREADY_SET:
              this.props.setProfileAdsError('Auto obnova za ovaj oglas je već postavljena'); break
            case AdApi.setAutoRefreshResponseStatuses.NO_AUTO_REFRESH_ADDON:
              this.props.setProfileAdsError('Nemate aktiviran dodatak za Auto Obnovu'); break
            default: break
          }
        } else {
          switch (status) {
            case AdApi.clearAutoRefreshResponseStatuses.NO_AUTO_REFRESH_SET:
              this.props.setProfileAdsError('Auto obnova za ovaj oglas nije postavljena'); break
            default: break
          }
        }
        this.props.updateAdById(adId, {isLoading: false})
      }
    }
  }

  render () {
    return (
      <div className='moji-oglasi-akcije-item'>
        <a href='javascript:void(0)'
          onClick={this.toggleAutoRefresh}
          title={this.props.autoRefresh ? 'Isključi' : 'Uključi'}
        >
          <i className='ico-obnovi-oglas ico' style={{color: this.props.autoRefresh ? 'green' : 'red'}} />
          Auto obnova
        </a>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: getUserInfo(state)
  }
}

AutoRefresh.propTypes = {
  adId: PropTypes.number.isRequired,
  updateAdById: PropTypes.func.isRequired,
  setProfileAdsError: PropTypes.func.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  autoRefresh: PropTypes.bool.isRequired,
  initRefresh: PropTypes.bool.isRequired
}

export default connect(mapStateToProps, {updateAdById, setProfileAdsError, fetchUserInfo})(AutoRefresh)
